// global window
export function getLink(proposal) {
  if (!proposal || !proposal.id) return '';
  return `${window.location.origin}/${proposal.link_path || 'v1/r/' + proposal.id}`;
}